import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMathLessThan"><Path fillRule="evenodd" clipRule="evenodd" d="M18.9602 6.30531C18.8526 6.05099 18.5593 5.93205 18.3049 6.03965L5.30494 11.5396C5.11995 11.6179 4.99976 11.7993 4.99976 12.0001C4.99976 12.201 5.11995 12.3823 5.30494 12.4606L18.3049 17.9606C18.5593 18.0682 18.8526 17.9493 18.9602 17.695C19.0678 17.4406 18.9489 17.1472 18.6946 17.0396L6.78299 12.0001L18.6946 6.96061C18.9489 6.85302 19.0678 6.55963 18.9602 6.30531Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathLessThan;
